export const ADMIN_SETTING_TYPES = {
  APP_VERSION: 1,
  PROFILE_COMPLETION_OVERLAY: 2,
};

export const DEFAULT_PROFILE_COMPLETION_OVERLAY = {
  showProfileCompletionOverlay: false,
  overlayType: "simple",
};
